import {kSystemTexts} from "../../../constants/texts";
import CoursesSubthemeHeaderCounter from "./CoursesSubthemeHeaderCounter";

export default function CoursesSubthemesContentHeader({subthemesCount, levelAsCount}) {
    // Used in ParameterCoreContent to display Subthemes
    // LevelAs header

    // BUILD
    return (
        <div className={"bg-backgroundLight5 w-full flex items-center shadow-[inset_0px_1px_2px_rgba(82,96,120,1)]"}>
            <CoursesSubthemeHeaderCounter text={kSystemTexts.themes}
                                          count={subthemesCount}
                                          extraClass={"w-2/5 px-[16px] py-[12px] border-r-[1px] border-greyLight3"} />
            <div className={"h-full w-[1px] min-w-[1px] bg-greyLight3"}>
            </div>
            <div className={"w-3/5 px-[16px] flex justify-start items-center"}>
                <CoursesSubthemeHeaderCounter text={kSystemTexts.skills}
                                              count={levelAsCount}
                                              extraClass={"py-[12px]"} />
            </div>
        </div>
    );
}